import { WITNESSES_ACTIONS } from 'constants/Actions/Witness';

// Estado inicial del reducer
const aInitialState = {
    aActiveWitnesses: [],
    aAllWitnesses: [],
    nTotalPages: 0,
    oWitness: null,
    bIsSuccess: false,
    nNewId: null,
    bIsError: false,
    bIsDelete: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los testigos del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const WitnessReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case WITNESSES_ACTIONS.GET_ALL:
            return { ...aState, aAllWitnesses: oAction.data };
        case WITNESSES_ACTIONS.GET_ACTIVE:
                return { ...aState, aActiveWitnesses: oAction.data };
        case WITNESSES_ACTIONS.FIND:
            return { ...aState, oWitness: oAction.data };
        case WITNESSES_ACTIONS.DELETE:
            return { ...aState, bIsDelete: true };
        case WITNESSES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data ? oAction.data : null };
        case WITNESSES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case WITNESSES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, nNewId: null, bIsError: false, bIsDelete: false, oWitness: null };
        case WITNESSES_ACTIONS.RESET:
            return { ...aState, bIsSuccess: false, nNewId: null, bIsError: false, bIsDelete: false };
        default:
            return aState;
    }
}
